






































































































import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";

interface LeafCategory {
  name: string;
  namePath: string;
}

interface Subcategory {
  name: string;
  namePath: string;
  subcategories: LeafCategory[];
}

interface Category {
  name: string;
  subcategories: Subcategory[];
  namePath: string;
}

@Component({
  components: {},
})
export default class BulkCategorySelection extends Vue {
  @Provide("$api") $api: any;
  @Provide("$_") $_: any;

  @Prop({ default: [] }) private categoryPaths!: string[];

  selectedCategoryPaths: string[] = this.categoryPaths;
  categories: Category[] = [];
  isDefaultProfile = false;
  profileName = "";
  isProfileNameInvalid = false;
  loading = false;

  mounted() {
    this.$store.commit("startLoading");
    this.loading = true;
    this.$api
      .get("api/categories/all")
      .then((result: any) => {
        this.categories = result.data;
        this.selectedCategoryPaths = this.expandedCategoryPaths(
          this.selectedCategoryPaths
        );
        this.$store.commit("stopLoading");
        this.loading = false;
      })
      .catch((error) => this.$store.commit("stopLoading"));
  }

  @Watch("selectedCategoryPaths")
  onCatgoryPathsChanged() {
    this.$emit("updateCategoryPaths", this.dedupedCategoryPaths());
  }

  isSelected(namePath: string) {
    return this.selectedCategoryPaths.includes(namePath);
  }

  private onCategoryClicked(e, category: Category) {
    this.toggleCategoryPathSelection(category.namePath);
  }

  private onSubcategoryClicked(e, subcategory: Subcategory) {
    this.toggleCategoryPathSelection(subcategory.namePath);
  }

  private onLeafClicked(e, leaf: LeafCategory) {
    this.toggleCategoryPathSelection(leaf.namePath);
  }

  private toggleCategoryPathSelection(namePath: string) {
    if (this.selectedCategoryPaths.indexOf(namePath) >= 0) {
      this.selectedCategoryPaths = this.selectedCategoryPaths.filter(
        (p) => !p.startsWith(namePath)
      );
    } else {
      this.selectedCategoryPaths = [...this.selectedCategoryPaths, namePath];
    }
  }

  private dedupedCategoryPaths() {
    const allPaths = this.selectedCategoryPaths;
    return this.selectedCategoryPaths.filter((path) => {
      return !allPaths
        .filter((p) => p !== path)
        .some((p) => p.startsWith(path) && p.length > path.length);
    });
  }

  private expandedCategoryPaths(categoryPaths: string[]): string[] {
    const allPaths = categoryPaths.flatMap((path) => {
      const splits = path.split(" > ");
      return [
        splits[0],
        splits.length >= 2 ? `${splits[0]} > ${splits[1]}` : splits[0],
        splits.length === 3 ? path : splits[0],
      ];
    });
    return [...new Set(allPaths)];
  }
}
